import { FC, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import { useCreateContractorDriverPumpPriceMutation } from 'bus/contractorDriverPumpPrice/services';
import { ContractorDriverPumpPriceCreate } from 'bus/contractorDriverPumpPrice/types';

import { ContractorDriverPumpPriceForm } from '../../components';

type Props = {
  onRefresh: () => void;
  contractorId: number;
};

const PUMP_SALARY_CREATE: ContractorDriverPumpPriceCreate = {
  dateBegin: '',
  objectId: null,
  pumpLen: 0,
  minimalPumpDriverPrice: null,
  minimalPumpQuantity: null,
  pumpDriverOverPrice: null,
};

export const CreateContractorDriverPumpPriceModal: FC<Props> = ({ onRefresh, contractorId }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const objectDataStore: DataSource = useMemo(() => {
    const defaultFilter = [['parentId', '=', null], 'and', ['type', '=', 1]];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', { defaultFilter });
  }, [contractorId]);

  const [form, setForm] = useState<ContractorDriverPumpPriceCreate>({
    ...PUMP_SALARY_CREATE,
    contractorId: contractorId,
  });
  const [createContractorDriverPumpPrice] = useCreateContractorDriverPumpPriceMutation();

  const handleChange = (
    name: keyof ContractorDriverPumpPriceCreate,
    value: ContractorDriverPumpPriceCreate[keyof ContractorDriverPumpPriceCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    createContractorDriverPumpPrice(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание ставки водителям насоса"
      visible
      isLoadingSubmit={false}
      width={600}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <ContractorDriverPumpPriceForm form={form} onChange={handleChange} storeObject={objectDataStore} type="CREATE" />
    </ModalForm>
  );
};
